import { render } from "./Column202412.vue?vue&type=template&id=68b3eafa&scoped=true"
import script from "./Column202412.vue?vue&type=script&lang=js"
export * from "./Column202412.vue?vue&type=script&lang=js"

import "./Column202412.vue?vue&type=style&index=0&id=68b3eafa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b3eafa"]])

export default __exports__